<template>
  <v-container>
    <p>Cleaning supply</p>
    <v-row>
      <v-col
        cols="12"
        lg="10"
        md="12"
      >
        <v-row>
          <v-col
            cols="4"
            md="2"
          >
            <p>Name:</p>
          </v-col>
          <v-col
            cols="8"
            md="4"
          >
            <p>{{ cleaning_supply.name || '-' }}</p>
          </v-col>
          <v-col
            cols="4"
            md="2"
          >
            <p>Price:</p>
          </v-col>
          <v-col
            cols="8"
            md="4"
          >
            <p>{{ cleaning_supply.price || '-' }}</p>
          </v-col>
        </v-row>
        <app-supplier-list
          :supplier_list="supplier_list"
        />
        <v-divider></v-divider>
        <div class="text-left">
          <v-btn
            class="mx-2"
            small
            exact
            :to="{ name: 'cleaning-supply-list' }"
          >
            Back
          </v-btn>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { authHeader } from '../../../_helpers';
export default {
  name: "CleaningSupplyView",
  components: {
    AppSupplierList: () => import('../components/supplier-list.view')
  },
  data: () => ({
    cleaning_supply_id: null,
    cleaning_supply: {
      name: null,
      price: null
    },
    supplier_list: [],
    rules: {
      require: value => !!value || 'Please fill in information',
    },
  }),
  async mounted () {
    let id = this.$route.params.id
    this.getCleaningSupply(id)
  },
  methods: {
    async getCleaningSupply (id) {
      this.cleaning_supply_id = id
      try {
        const result = await this.$http.get(`/back-office/cleaning-supplies/${this.cleaning_supply_id}`, authHeader())
        this.cleaning_supply.name = result.data.name
        this.cleaning_supply.price = result.data.price
        for (let supplier of result.data.Suppliers) {
          this.supplier_list.push({
            id: supplier.id,
            name: supplier.name,
            branch: supplier.branch
          })
        }
      } catch (err) {
        console.log(err)
        alert('Something went wrong')
      }
    },
  },
};
</script>
